import React from "react";

export default function PdfReportDocument({ children, styles, title }) {
  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <title>{title || ""}</title>
        <style>{styles}</style>
      </head>
      <body>{children}</body>
    </html>
  );
}
